import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Footer from "../components/Footer";
import Header from "../components/header";
import Hero from "../components/Hero";
import VillaList from "../components/VillaList";
import BackToTop from "../components/BackToTop";
import WhatsappButton from "../components/WhatsappButton";
import { Helmet } from "react-helmet-async";
import { getAllProperties, propertiesToArray } from "../Functions/FetchProperties";

const Properties = () => {
    const location = useLocation();
    const [activeLocation, setActiveLocation] = useState("");
    
    // Extract location from URL and set it for child components
    useEffect(() => {
        const queryParams = new URLSearchParams(location.search);
        const locationParam = queryParams.get('location') || "";
        setActiveLocation(locationParam);
    }, [location.search]);

    // Add effect to load the CSS file and preload location data
    useEffect(() => {
        // Load the CSS file for this page
        const link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = '/assets/css/Properties.css';
        document.head.appendChild(link);
        
        // Preload locations data if not in session storage
        const preloadLocationsData = async () => {
            const cachedData = sessionStorage.getItem('propertyLocationsData');
            
            // If we don't have cached data or it's expired, preload it
            if (!cachedData) {
                try {
                    const propertiesData = await getAllProperties();
                    const propertiesArray = propertiesToArray(propertiesData);
                    
                    // Extract and cache location information
                    const locationSet = new Set();
                    const locationCounts = {};
                    
                    propertiesArray.forEach(prop => {
                        if (prop.location) {
                            let locationKey = prop.location;
                            
                            if (prop.location.toLowerCase().includes('pattaya') || 
                                prop.location.toLowerCase().includes('thailand')) {
                                locationKey = 'Pattaya, Thailand';
                            }
                            
                            locationSet.add(locationKey);
                            locationCounts[locationKey] = (locationCounts[locationKey] || 0) + 1;
                        }
                    });
                    
                    // Cache the data
                    const cacheData = {
                        timestamp: Date.now(),
                        locations: [...locationSet].sort(),
                        locationCounts: locationCounts,
                        totalProperties: propertiesArray.length
                    };
                    
                    sessionStorage.setItem('propertyLocationsData', JSON.stringify(cacheData));
                } catch (error) {
                    console.error("Error preloading locations data:", error);
                }
            }
        };
        
        preloadLocationsData();
        
        // Clean up by removing the CSS when component unmounts
        return () => {
            document.head.removeChild(link);
        };
    }, []);

    return (
        <div className="properties-page">
            <Helmet>
                <title>Luxury Villas & Properties | LSQ Stays Property Listings</title>
                <meta name="description" content="Browse our exclusive collection of luxury villas and properties. Find your perfect vacation rental in top destinations with LSQ Stays." />
                <link rel="canonical" href="https://www.lsqstays.in/properties" />
                <script type="application/ld+json">
                {JSON.stringify({
                    "@context": "https://schema.org",
                    "@type": "CollectionPage",
                    "headline": "Luxury Villas & Properties",
                    "description": "Browse our exclusive collection of luxury villas and properties. Find your perfect vacation rental.",
                    "url": "https://www.lsqstays.in/properties",
                    "publisher": {
                        "@type": "Organization",
                        "name": "LSQ Stays",
                        "logo": {
                            "@type": "ImageObject",
                            "url": "https://www.lsqstays.in/assets/Images/logo.png",
                            "width": 112,
                            "height": 112,
                            "contentUrl": "https://www.lsqstays.in/assets/Images/logo.png"
                        }
                    }
                })}
                </script>
            </Helmet>
            <Header currentPage="properties" />
            <Hero isPropertiesPage={true} initialLocation={activeLocation} />
            <div className="container mt-2 mb-5">
                <div className="row">
                    <VillaList />
                </div>
            </div>
            <Footer />
            <BackToTop />
            <WhatsappButton />
        </div>
    );
}

export default Properties;